import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';

import Aos from "aos";

import ScrollToTop from '../../Shared/ScrollToTop';
import Footer from '../../layout/Footer/Footer';
import Header from '../../layout/Header/Header';
import Media from 'react-media';

import viande from '../../../images/produits/viande.jpg';
import poisson from '../../../images/produits/poisson.webp';
import crevette from '../../../images/produits/crevette.webp';
import pic4 from '../../../images/produits/charcuterie.webp';
import pic5 from '../../../images/produits/vegetable.jpg';
import Oeufs from '../../../images/produits/box.webp';
import datte from '../../../images//produits/datte.webp';
import './Produits.css'
import { datas } from './Data'
import { useTranslation } from "react-i18next";

const Produits = ({ lang, SetLang }) => {
    const [t, i18n] = useTranslation('traduction');

    useEffect(() => {
        Aos.init({
            duration: 1500,
            disable: 'mobile',
            once: true,
            mirror: false
        });
        i18n.changeLanguage(lang);
    }, [i18n, lang]);

    return (<>
        <Header lang={lang} SetLang={SetLang} />


        <div class="page-content bg-white">
            <div class="content-block">
                <div class="section-full">
                    <div class="row spno about-industry">
                        <div class="col-lg-8 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s">
                            <div class="dlab-post-media dlab-img-effect zoom">
                                <img src={viande} alt="" class="img-cover" />
                            </div>
                        </div>
                        <div class="col-lg-4 bg-white wow fadeIn Viande-Volaille" data-wow-duration="2s" data-wow-delay="0.4s">
                            <div class="service-box style2">
                                <div>
                                    <h2 class="title text-black"><span>{t('Viande et Volaille')}</span></h2>
                                    <p>{t('Notre emballage self-service auto-absorbant, composé à 100% de mousse de polystyrène est la solution idéale pour vos Viandes et Volailles. La gamme DP absorbeur de liquide est facile pour le conditionnement sur le lieu de vente.')}</p>
                                    <Link to="Produits/viande" class="site-button outline outline-2 btnhover11">{t('Suite...')}</Link>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.6s">
                            <div class="dlab-post-media dlab-img-effect zoom">
                                <img src={poisson} alt="" class="img-cover" />
                            </div>
                        </div>
                        <div class="col-lg-4 bg-secondry text-white wow fadeIn" data-wow-duration="2s" data-wow-delay="0.8s">
                            <div class="service-box style2 poisson">
                                <div>
                                    <h2 class="title"><span>{t('Poisson')}</span></h2>
                                    <p>{t('Notre emballage self-service auto-absorbant, composé à 100% de mousse de polystyrène est la solution idéale pour vos Possion et Fruits De Mer. La gamme DP absorbeur de liquide est facile pour le conditionnement sur le lieu de vente.')}</p>
                                    <Link to="/Produits/poisson" class="site-button outline white outline-2 btnhover11">{t('Suite...')}</Link>
                                </div>
                            </div>
                        </div>
                        <Media query="(min-width: 991px)" render={() =>
                        (
                            <>
                                <div class="col-lg-4 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s">
                                    <div class="dlab-post-media dlab-img-effect zoom">
                                        <img src={crevette} alt="" class="img-cover" />
                                    </div>
                                </div>  <div class="col-lg-4 bg-primary text-white wow fadeIn" data-wow-duration="2s" data-wow-delay="0.4s">
                                    <div class="service-box style2">
                                        <div>
                                            <h2 class="title"><span>{t('Saucisse')}</span></h2>
                                            <p>{t('Nous offrons une variété de barquettes alimentaires fabriquées avec 100% de mono-matériau. Ces barquettes sont disponible en nombreux formats et couleurs. ')}</p>
                                            <Link to="/Produits/charcuterie" class="site-button outline white outline-2 btnhover11">{t('Suite...')}</Link>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        />


                        <div class="col-lg-4 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.6s">
                            <div class="dlab-post-media dlab-img-effect zoom">
                                <img src={pic4} alt="" class="img-cover" />
                            </div>
                        </div>
                        <div class="col-lg-4 bg-primary text-white wow fadeIn" data-wow-duration="2s" data-wow-delay="0.8s">
                            <div class="service-box style2">
                                <div>
                                    <h2 class="title text-black"><span>{t('Fromage')} </span></h2>
                                    <p>{t('Nous offrons une variété de barquettes alimentaires fabriquées avec 100% de mono-matériau. Ces barquettes sont disponible en nombreux formats et couleurs. ')} </p>
                                    <Link to="/Produits/charcuterie" class="site-button outline white outline-2 btnhover11">{t('Suite...')}</Link>
                                </div>
                            </div>
                        </div>

                        <Media query="(max-width: 991px)" render={() =>
                        (
                            <div class="col-lg-8 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.4s">
                                <div class="dlab-post-media dlab-img-effect zoom">
                                    <img src={pic5} alt="" class="img-cover" />
                                </div>
                            </div>
                        )}
                        />


                        <div class="col-lg-4 bg-white wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s">
                            <div class="service-box style2 ">
                                <div>
                                    <h4 class="title text-black"><span>{t('FRUITS  & LEGUMES')}</span></h4>
                                    <p>{t('Nous offrons une variété de barquettes alimentaires fabriquées avec 100% de mono-matériau. Ces barquettes sont disponible en nombreux formats et couleurs. Ces barquettes non absorbantes conviennent au conditionnement des aliments frais dont la durée de conservation est courte.')}</p>
                                    <Link to="/Produits/fruits" class="site-button outline outline-2 btnhover11">{t('Suite...')}</Link>
                                </div>
                            </div>
                        </div>
                        <Media query="(min-width: 991px)" render={() =>
                        (
                            <div class="col-lg-8 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.4s">
                                <div class="dlab-post-media dlab-img-effect zoom">
                                    <img src={pic5} alt="" class="img-cover" />
                                </div>
                            </div>
                        )}
                        />


                        <div class="col-lg-8 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s">
                            <div class="dlab-post-media dlab-img-effect zoom">
                                <img src={Oeufs} alt="" class="img-cover" />
                            </div>
                        </div>
                        <div class="col-lg-4 bg-white wow fadeIn" data-wow-duration="2s" data-wow-delay="0.4s">
                            <div class="service-box style2">
                                <div>
                                    <h2 class="title text-black"><span>{t('Oeufs')}</span></h2>
                                    <p>{t('Nous offrons des valises en polystyrène expansé sécurisé pour vos Oeufs. Ces valises sont disponible en différentes tailles.')}</p>
                                    <Link to="/produits/oeufs" class="site-button outline outline-2 btnhover11">{t('Suite...')}</Link>
                                </div>
                            </div>
                        </div>
                        <Media query="(max-width: 991px)" render={() =>
                        (
                            <div class="col-lg-8 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.4s">
                                <div class="dlab-post-media dlab-img-effect zoom">
                                    <img src={datte} alt="" class="img-cover" />
                                </div>
                            </div>
                        )}
                        />
                        <div class="col-lg-4 bg-white wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s">
                            <div class="service-box style2">
                                <div>
                                    <h2 class="title text-black"><span>{t('Dattes')}</span></h2>
                                    <p>{t('Les barquettes DP-01, DP-02, DP-03 sont des barquettes de faible poids et de grande stabilité. Ces barquettes, proposé en différentes tailles, profondeurs et couleurs, sont les meilleurs pour vos dattes.')}</p>
                                    <Link to="/Produits/dattes" class="site-button outline outline-2 btnhover11">{t('Suite...')}</Link>
                                </div>
                            </div>
                        </div>
                        <Media query="(min-width: 991px)" render={() =>
                        (
                            <div class="col-lg-8 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.4s">
                                <div class="dlab-post-media dlab-img-effect zoom">
                                    <img src={datte} alt="" class="img-cover" />
                                </div>
                            </div>
                        )}
                        />

                    </div>
                </div>
            </div>
        </div>

        <Footer lang={lang} SetLang={SetLang} />

        <ScrollToTop className="scroltop style2 radius " />

    </>);
}

export default Produits;